import React from 'react'
import { Route, Switch, useParams } from 'react-router-dom'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { FleetPage } from '../../../../shared/sso-workspace/fleet-page'
import { IconNotification, IconSettings } from '../../../../shared/icon/icon'
import { InboxPage } from './inbox-page'
import { PreferencesPage } from './preferences-page'
import { DeliveryLog } from '../../admin/notify/delivery-log'
import { TimelineView } from '../../admin/notify/timeline-page'
import { SECTION } from '../../../../shared/navigation/sections'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'

// The inbox: Notification preferences sits under it (its route is a sibling,
// audit F12).
export const INBOX_CRUMB = { url: '/org/notifications', text: 'Notifications', Icon: IconNotification }

const OrgTimeline = () => {
  const { traceID } = useParams()
  return <TimelineView traceID={traceID} />
}

const OrgTimelineTrail = () => {
  const { traceID } = useParams()
  return <PageTrail trail={[SECTION.notificationActivity, { url: `/org/notification-activity/timeline/${traceID}`, text: 'Notification' }]} />
}

// The person's own notifications (everyone signed in; self-scoped, C-4) and
// the organization's notification activity: its own email and push
// deliveries, for everyone who can manage its users, super admins included
// (Email activity's rule, owner direction 2026-10-07: every organization's
// lives in the staff Notifications section). The server enforces the scope.
export const LayoutNotifications = () =>
  <Switch>
    <Route path="/org/notifications/preferences">
      <BreadcrumbView parent={INBOX_CRUMB} Icon={IconSettings} text="Notification preferences"><PreferencesPage /></BreadcrumbView>
    </Route>
    <Route path="/org/notifications" exact>
      <BreadcrumbView Icon={INBOX_CRUMB.Icon} text={INBOX_CRUMB.text}><InboxPage /></BreadcrumbView>
    </Route>
    <Route path="/org/notification-activity/timeline/:traceID">
      {/* Notification activity > Notification, the list a link back (audit F7). */}
      <OrgTimelineTrail />
      <FleetPage title="Notification activity" purpose="One notification's path: who it went to, how and what happened.">
        <OrgTimeline />
      </FleetPage>
    </Route>
    <Route path="/org/notification-activity" exact>
      <BreadcrumbView Icon={SECTION.notificationActivity.Icon} text={SECTION.notificationActivity.text}>
        <FleetPage title="Notification activity" purpose="Email and push notifications EducationXR sent for your organization and what happened to them.">
          <DeliveryLog />
        </FleetPage>
      </BreadcrumbView>
    </Route>
  </Switch>
